import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '@card-software/nexus-utilities';
import { Recipe } from '../../models/recipe/recipe';

@Injectable({
  providedIn: 'root',
})
export class RecipeProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.itemApi + '/api/v1/recipe';

  public getAllRecipes(): Observable<ApiResponse<Recipe[]>> {
    return this.httpClient.get<ApiResponse<Recipe[]>>(`${this.baseUrl}/all`);
  }

  public getRecipeById(id: string): Observable<ApiResponse<Recipe>> {
    return this.httpClient.get<ApiResponse<Recipe>>(`${this.baseUrl}/${id}`);
  }

  public getRecipesByLabDipReference(labDipReference: string): Observable<ApiResponse<Recipe[]>> {
    return this.httpClient.get<ApiResponse<Recipe[]>>(`${this.baseUrl}/by-labdip/${labDipReference}`);
  }

  public createRecipe(recipe: Recipe, typeNumber = 0): Observable<ApiResponse<Recipe>> {
    return this.httpClient.post<ApiResponse<Recipe>>(`${this.baseUrl}?typeNumber=${typeNumber}`, recipe);
  }

  public updateRecipe(id: string, recipe: Recipe): Observable<ApiResponse<Recipe>> {
    return this.httpClient.put<ApiResponse<Recipe>>(`${this.baseUrl}/${id}`, recipe);
  }

  public deleteRecipe(id: string): Observable<ApiResponse<void>> {
    return this.httpClient.delete<ApiResponse<void>>(`${this.baseUrl}/${id}`);
  }
}
